import { App } from 'vue'
import Label from './LpLabel.vue'

Label.install = (Vue: App) => {
  Vue.component(Label.name, Label)
}

export default Label
